import { EEnvironmentId } from 'apps/idl/src/model/application/EEnvironmentId';
import { IStatusBarConfig } from 'apps/idl/src/model/statusBar/IStatusBarConfig';
import { IIdlEnvironment } from '../model/IIdlEnvironment';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const APP_ID = "idl";
export const APP_CORE_DATABASE_PREFIX = `${APP_ID}_core_`;

export const environment: IIdlEnvironment = {
	production: false,
	id: EEnvironmentId.dev1,
	description: "DEV1",
	cloud_url: "https://dev-api.desmos-infirmiers.juxta.network",
	coreRoleAppConfig: `${APP_CORE_DATABASE_PREFIX}common_app_configs`,
	statusBar: { backgroundColorByHexString: "#ffbc00" },
	GOOGLE_MAPS_BROWSER_API_KEY: "AIzaSyCIyQyPoFRFpBwGKvfqbyYcy8Ut2DZokts",
	GOOGLE_MAPS_IOS_API_KEY: "AIzaSyCIyQyPoFRFpBwGKvfqbyYcy8Ut2DZokts",
	API_KEY: "MDI2Njc2ZTM4YWY0MzU4YzEyZGY4YmVmOTUxODY4YWY",
	survicate_workspaceId: "49f67a8f0aeaa10d8dae18e39ef301f4",
	urlWebApp: "https://VAR_WEBAPP_URL",
	appleAppId: "6474615576",


	cloud_api_suffix: "/api/",
	cloud_dms_suffix: "/dms/idl/documents/",
	cloud_api_data_suffix: `/api/apps/${APP_ID}/data/`,
	cloud_api_apps_suffix: `/api/apps/${APP_ID}/`,

	fsv_url: "https://infirmiers-desmossv.juxta.network",
	fsv_teletransmission_url: "https://infirmiers-desmossv.juxta.network/Pages/Post/FSE-DRE/Fsv_Teletransmission.aspx",

	dms: {},

	appCredentials: {
		login: "idl",
		password: "abozifec"
	},

	credentials: {
		login: "",
		password: ""
	},

	excludeLogins: [
		"invite.idl@idelizy.fr"
	],

	accountBlockedMessage: "Votre compte est bloqué, vous devez réinitialiser votre mot de passe",

	unlockRequired: true,
};

export const statusBar: IStatusBarConfig = { backgroundColorByHexString: "#ffbc00" };

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.